module.exports = __webpack_public_path__ + "img/close-icon.ce0ced37.svg";